import { Typography } from '@mui/material'
import { FieldValues, UseFormWatch } from 'react-hook-form'
import { InvoiceDetail } from '../../../PendingReceivementsTypes'

const sum = (list: InvoiceDetail[] | number[], attribute?: string) => (list.length > 0 ? list.map((item) => (attribute ? item[attribute] : item || 0)).reduce((previous: number, next: number) => previous + next) : 0)

export const resolveTableFooter = (details?: InvoiceDetail[], watch?: UseFormWatch<FieldValues>) => {
  if (!details) return []

  const receivedQuantity = `${sum(details, 'receivedQuantity')} ${details[0].measureUnit}`
  const expectedQuantity = `${watch ? sum(details.map((detail, index) => (detail.boxQuantity * (watch(`qty-per-box-row-${index}`) ?? detail.qtyPerBox)))) : sum(details, 'expectedQuantity')} ${details[0].measureUnit}`

  const footerInformation = [
    `Qtd. Recebida = ${receivedQuantity}`,
    `Qtd. Esperada = ${expectedQuantity}`,
  ]

  return footerInformation.map((information: string) => (<Typography width='25%' textAlign='center' fontWeight='bold' fontSize='14px'>{information}</Typography>))
}
